const getLocaleDecimalSeparator = (locale) =>
  Intl.NumberFormat(locale).format(1.1).substring(1, 2)

const getDecimalsByLocale = (amount, locale) => {
  const decimalSeparator = getLocaleDecimalSeparator(locale)

  const regExp = decimalSeparator === '.' ? /\.(\d+)/ : /,(\d+)/

  const [, matchingDecimals = ''] = amount.match(regExp) ?? []

  return matchingDecimals
}

const adjustDecimals = (amount, locale) => {
  const matchingDecimals = getDecimalsByLocale(amount, locale)

  let formattedAmount = ''

  switch (matchingDecimals.length) {
    case 0:
      formattedAmount = `${amount}.00`
      break
    case 1:
      formattedAmount = `${amount}0`
      break
    case 2:
      formattedAmount = amount
      break
    default:
      formattedAmount =
        matchingDecimals.length > 2
          ? `${amount.replace(
              new RegExp(matchingDecimals),
              ''
            )}${matchingDecimals.substring(0, 2)}`
          : amount
      break
  }

  return formattedAmount
}

export const formatAmount = (amount, locale = 'en-US') => {
  const formattedAmount = amount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return adjustDecimals(formattedAmount, locale)
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
})

export default formatter
